export const CONTACT = {
  phone: "0765851520",
  phoneDisplay: "07 65 85 15 20",
  email: "contact.sandroservice@gmail.com",
  zone: "Alpes-Maritimes (06)",
  address: "5 rue Jean Augier, 06260 Saint-Antonin",
  city: "Saint-Antonin (06260)",
};

export const LEGAL = {
  raison: "Sandro Services 06",
  statut: "Entreprise individuelle — Auto-entrepreneur",
  siret: "105 596 258 00019",
  rcs: "RCS Nice 105 596 258",
  ape: "81.21Z",
  tva: "Non soumis à la TVA (art. 293 B du CGI)",
  address: "5 rue Jean Augier, 06260 Saint-Antonin",
  host: "Emergent",
};

export const NAV = [
  { label: "Accueil", to: "/" },
  { label: "Nos services", to: "/services" },
  { label: "Parcs & Jardins", to: "/parcs-jardins" },
  { label: "Nettoyage extérieur", to: "/nettoyage-exterieur" },
  { label: "Petites réparations", to: "/petites-reparations" },
  { label: "À propos", to: "/a-propos" },
  { label: "Zone d'intervention", to: "/zone-intervention" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_TYPES = [
  "Parcs & jardins", "Débroussaillage", "Création / aménagement",
  "Restauration de jardin", "Nettoyage de façade", "Nettoyage d'allée / cour",
  "Nettoyage de terrasse", "Traitement anti-mousse", "Hydrofuge",
  "Petites réparations", "Autre",
];
